module.exports = {"title":"Sorry!","description":"The browser you are using is not supported.<br />Please come back using Chome, Safari or Firefox.","close":"Close"}


//////////////////
// WEBPACK FOOTER
// ./src/components/EventListing/BrowserNotSupportedModal/locales/fr.json
// module id = 1321
// module chunks = 0